<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <rect
            x="2"
            y="7.5"
            width="20"
            height="9"
            rx="2"
            stroke="#171B25"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path d="M2 4.5L22 4.5" stroke="#171B25" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M2 19.5L22 19.5" stroke="#171B25" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</template>
